import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {DiscordLinkStatus} from '@/app/core/models/discord';

@Injectable({
	providedIn: 'root'
})
export class DiscordService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly AUTH_URI = `${environment.backendUrl}/auth/discord`;
	private readonly SERVICE_URI = `${environment.backendUrl}/user/discord`;

	getAuthorizeUrl(): Observable<{ url: string }> {
		return this.http.get<{ url: string }>(`${this.AUTH_URI}/authorize`);
	}

	getLinkStatus(): Observable<DiscordLinkStatus> {
		return this.http.get<DiscordLinkStatus>(`${this.SERVICE_URI}/me`);
	}

	unlink(): Observable<void> {
		return this.http.delete<void>(`${this.SERVICE_URI}/me`);
	}
}
